<template>
  <v-card class="mx-auto" min-height="60vh">
    <v-toolbar dense color="indigo">
      <v-row>
        <v-col class="text-start" cols="3">
          <v-toolbar-title class="white--text">
            Avanza Carrello
          </v-toolbar-title>
        </v-col>
        <v-col cols="6">
          <!-- ROW PULSANTI -->
          <v-row justify="center">
            <v-col cols="2">
              <!-- STAMPA QR -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="apriDialog()" v-bind="attrs" v-on="on" small>
                    <v-icon color="primary">mdi-printer</v-icon>
                  </v-btn>
                </template>
                <span>Stampa</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" v-if="work_order.fase_precedente != null">
              <!-- LETTORE QR -->
              <DataMatrixReader ref="qr" v-on:detectQrCode="detectQrCode" />
            </v-col>
            <v-col cols="2" v-if="work_order.fase_precedente != null">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickSelezioneManualeSeriale"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="primary">mdi-numeric</v-icon>
                  </v-btn>
                </template>
                <span>Selezione Seriale</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2">
              <!-- SEGNALAZIONI -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="apriDialogSegnalazioni()"
                  >
                    <v-icon color="orange">mdi-alert</v-icon>
                  </v-btn>
                </template>
                <span>Genera Segnalazione</span>
              </v-tooltip>
            </v-col>
            <!-- SALVA E AVANZA -->
            <v-col v-if="work_order.fase_precedente != null" cols="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="clickAvanza" v-bind="attrs" v-on="on" small>
                    <v-icon color="success">mdi-floppy</v-icon>
                  </v-btn>
                </template>
                <span>Avanza</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="text-end" cols="3">
          <!-- CHIUDI DIALOG -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small @click="chiudiDialog">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <!-- Tabella -->
          <v-data-table
            v-if="items_fase_precedente.length > 0"
            hide-default-footer
            :headers="headers"
            fixed-header
            :items="items_fase_precedente"
            :items-per-page="10"
            item-key="id_commessa_dettaglio"
            class="elevation-1 my-5"
            calculate-widths
          >
            <!-- Intestazione tabella -->
            <template v-slot:top>
              <v-toolbar color="indigo" dense class="rounded rounded-b-0">
                <v-toolbar-title class="white--text">
                  Dati Fase Precedente
                </v-toolbar-title>
              </v-toolbar>
            </template>
          </v-data-table>
          <v-card
            class="d-flex justify-center align-center my-5"
            v-else
            height="145px"
          >
            <v-card-text style="font-size: 20px">
              Nessun dato disponibile da Fase Precedente
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-toolbar color="indigo" dense class="rounded rounded-b-0">
        <v-toolbar-title class="white--text">
          Dati Attuali
        </v-toolbar-title>
      </v-toolbar>
      <v-row class="mt-2" justify="center">
        <!-- ROW CAMPI DI INPUT -->
        <v-col cols="3">
          <!-- TEMPERATURA -->
          <v-text-field
            v-model.number="carrello.temperatura"
            hide-spin-buttons
            type="number"
            dense
            hide-details
            label="Temperatura (C°)"
          />
        </v-col>
        <v-col cols="3">
          <!-- UMIDITA -->
          <v-text-field
            v-model.number="carrello.umidita"
            hide-spin-buttons
            type="number"
            dense
            hide-details
            label="Umidità (%)"
          />
        </v-col>
        <v-col cols="3">
          <!-- TARA -->
          <!-- :readonly="work_order.fase_precedente!==null" -->
          <v-text-field
            @input="calcoloPesoNettoDelta"
            v-model.number="carrello.tara"
            hide-spin-buttons
            type="number"
            dense
            hide-details
            label="Peso Tara"
            :disabled="work_order.fase_precedente != null"
          />
        </v-col>
        <v-col cols="3">
          <!-- PESO LORDO -->
          <v-text-field
            @input="calcoloPesoNettoDelta"
            v-model.number="carrello.peso_lordo"
            hide-spin-buttons
            type="number"
            dense
            outlined
            hide-details
            style="font-size: 20px; font-weight: bold"
            label="Peso Lordo"
          />
        </v-col>
        <v-col
          v-if="items_fase_precedente.length > 0"
          class="text-center"
          cols="12"
        >
          <!-- DELTA -->
          <span style="font-size: 20px; font-weight: bold; color: black"
            >Delta Peso: {{ Number(delta).toFixed(2) }} KG</span
          >
          <span
            style="
              margin-left: 20px;
              font-size: 20px;
              font-weight: bold;
              color: black;
            "
            >{{ delta_perc }}%</span
          >
        </v-col>
      </v-row>
    </v-card-text>
    <!-- DIALOG SEGNALAZIONI -->
    <v-dialog v-model="dialog_segnalazioni">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeSegnalazioni"
            :component="'anomalie'"
            :input_args="input_args"
            @salvati_disegni="handleSalvatiDisegni"
            :key="key_segnalazioni"
          />
        </div>
      </v-card>
    </v-dialog>
    <!-- DIALOG Chiudi fase -->
    <v-dialog v-model="dialog_salva_fase" width="600">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Scelta Azione </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="dialog_salva_fase = false"
                small
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-10" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Vuoi chiudere la fase a seguito di questa registrazione?
          </span>

          <!-- Spazio della select -->
          <v-container class="mt-5" fluid>
            <v-row
              align="center"
              justify="center"
              v-show="work_order.flag_fase_ultima == 1"
            >
              <v-col class="my-0 py-0" align="center" cols="12">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_magazzini"
                  item-value="id_magazzino"
                  item-text="des_magazzino"
                  label="Magazzino"
                  outlined
                  v-model="id_magazzino_sel"
                  style="border-radius: 0px; max-width: 200px"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-10" @click="chiudiFase(0)">Registra</v-btn>

                <v-btn class="ml-10" @click="chiudiFase(1)"
                  >Registra e Chiudi</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG cerca_seriale -->
    <v-dialog v-model="dialog_stampa_etichetta" width="600">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Ristampa </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="
                  dialog_stampa_etichetta = false;
                  conferma_stampa_visible = false;
                  conferma_stampa_e_chiudi_visible = false;
                "
                small
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-10" style="overflow-y: auto">
          <span
            style="color: rgb(0, 0, 0); font-size: 18px"
            v-if="work_order.fase_precedente == null"
          >
            Vuoi chiudere la fase a seguito di questa stampa?
          </span>

          <span style="color: rgb(0, 0, 0); font-size: 18px" v-else>
            Seleziona il seriale da ristampare.
          </span>

          <v-divider class="my-5"></v-divider>

          <v-container fluid>
            <v-row
              align="center"
              justify="center"
              v-if="work_order.fase_precedente == null"
            >
              <span
                v-if="
                  conferma_stampa_visible === false &&
                  conferma_stampa_e_chiudi_visible === false
                "
              >
                <!-- Bottoni di stampa semplice o stampa con chiusura -->
                <v-col class="my-0 py-0" justify="center" cols="12">
                  <v-btn class="mr-10" @click="conferma_stampa_visible = true">
                    Stampa
                  </v-btn>

                  <v-btn
                    class="ml-10"
                    @click="conferma_stampa_e_chiudi_visible = true"
                  >
                    Stampa e Concludi Fase
                  </v-btn>
                </v-col>
              </span>

              <!-- Bottoni di stampa semplice con o senza nuovo lotto -->
              <span v-else-if="conferma_stampa_visible === true">
                <v-col class="my-0 pt-0 pb-5" justify="center" cols="12">
                  <span style="color: rgb(0, 0, 0); font-size: 18px">
                    Stampa semplice
                  </span>
                </v-col>
                <v-col class="my-0 pt-0 pb-5" justify="center" cols="12">
                  <span style="color: rgb(0, 0, 0); font-size: 18px">
                    Lotto Attuale:
                    {{
                      work_order.cod_lotto_commessa == null ||
                      work_order.cod_lotto_commessa == ""
                        ? "N/D"
                        : work_order.cod_lotto_commessa
                    }}
                  </span>
                </v-col>
                <v-col class="my-0 py-0" justify="center" cols="12">
                  <v-btn
                    class="mr-10"
                    @click="stampaQR(0, 0, 0, carrello.seriale)"
                  >
                    Mantieni Lotto
                  </v-btn>

                  <v-btn
                    class="ml-10"
                    @click="stampaQR(0, 0, 1, carrello.seriale)"
                  >
                    Nuovo Lotto
                  </v-btn>
                </v-col>
              </span>

              <!-- Bottoni di stampa con chiusura con o senza nuovo lotto -->
              <span v-else>
                <v-col class="my-0 pt-0 pb-5" justify="center" cols="12">
                  <span style="color: rgb(0, 0, 0); font-size: 18px">
                    Stampa e Concludi Fase
                  </span>
                </v-col>
                <v-col class="my-0 pt-0 pb-5" justify="center" cols="12">
                  <span style="color: rgb(0, 0, 0); font-size: 18px">
                    Lotto Attuale:
                    {{
                      work_order.cod_lotto_commessa == null ||
                      work_order.cod_lotto_commessa == ""
                        ? "N/D"
                        : work_order.cod_lotto_commessa
                    }}
                  </span>
                </v-col>
                <v-col class="my-0 py-0" justify="center" cols="12">
                  <v-btn
                    class="mr-10"
                    @click="stampaQR(0, 1, 0, carrello.seriale)"
                  >
                    Mantieni Lotto
                  </v-btn>

                  <v-btn
                    class="ml-10"
                    @click="stampaQR(0, 1, 1, carrello.seriale)"
                  >
                    Nuovo Lotto
                  </v-btn>
                </v-col>
              </span>
            </v-row>
            <v-row align="center" justify="center" v-else>
              <v-col cols="12">
                <v-data-table
                  :headers="headers_seriali_manuali"
                  :items="items_seriali_manuali"
                  sort-by="seriale"
                  sort-desc
                >
                  <template v-slot:top>
                    <v-toolbar dense color="indigo">
                      <v-toolbar-title class="white--text">
                        Seriali Disponibili
                      </v-toolbar-title>
                    </v-toolbar>
                  </template>

                  <!-- Bottone di selezione -->
                  <template v-slot:[`item.selezionato`]="{ item }">
                    <v-btn small>
                      <v-icon
                        @click="stampaQR(1, 0, 0, item.seriale)"
                        color="success"
                        >mdi-check</v-icon
                      >
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQVStampa" />

      <!-- Overlay di caricamento -->
      <v-overlay :value="overlay_stampa">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Dialog di selezione manuale del seriale -->
    <v-dialog v-model="dialog_seriale_manuale" width="500">
      <v-card class="ma-0 pa-0" style="overflow: hidden">
        <v-card-text class="mx-0 px-0">
          <v-data-table
            :headers="headers_seriali_manuali"
            :items="
              items_seriali_manuali.filter(
                (elem) => elem.fase_ultima_registrazione <= work_order.cod_fase
              )
            "
            sort-by="seriale"
            sort-desc
          >
            <template v-slot:top>
              <v-toolbar dense color="indigo">
                <v-toolbar-title class="white--text">
                  Seriali Disponibili
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- Bottone di chiusura -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog_seriale_manuale = false"
                      small
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Chiudi</span>
                </v-tooltip>
              </v-toolbar>
            </template>

            <!-- Bottone di selezione -->
            <template v-slot:[`item.selezionato`]="{ item }">
              <v-btn small>
                <v-icon
                  @click="selezioneManualeSeriale(item.seriale)"
                  color="success"
                  >mdi-check</v-icon
                >
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import moment from "moment/moment";
import DataMatrixReader from "@/components/TOOLS/DataMatrixReader.vue";

class Carrello {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }
  setCampi() {
    const campi = [
      // { nome: "id_commessa_dettaglio_carrello", default_val: -1 },
      { nome: "base64", default_val: "" },
      { nome: "fase", default_val: "" },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_magazzino", default_val: null },
      { nome: "peso_lordo", default_val: 0 },
      { nome: "peso_netto", default_val: 0 },
      { nome: "seriale", default_val: -1 },
      { nome: "tara", default_val: 0 },
      { nome: "temperatura", default_val: 0 },
      { nome: "umidita", default_val: 0 },
      // { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  components: {
    WindowFrame,
    SnackbarQV,
    DataMatrixReader,
  },
  props: {
    work_order: Object,
  },
  data() {
    return {
      // Variabili di supporto
      carrello: new Carrello(),
      delta: 0,
      delta_perc: 0,
      id_magazzino_sel: null,
      input_args: {
        clear_on_save: true,
        cod_articolo: "",
        cod_documento: "",
        data_documento: "",
        destinazione: "",
        disegni_iniziali: [],
        id_articolo: 0,
        immagine_standard_editor: "",
        num_documento: "",
        riferimento: 0,
        return_array: true,
        show_close_button: true,
        show_editor_arrow_button: true,
        show_editor_camera_button: true,
        show_editor_circle_button: true,
        show_editor_color_picker_button: true,
        show_editor_crop_button: true,
        show_editor_edit_back_button: true,
        show_editor_edit_forward_button: true,
        show_editor_eraser_button: true,
        show_editor_free_draw_button: true,
        show_editor_large_size_button: true,
        show_editor_letter_case_button: true,
        show_editor_medium_size_button: true,
        show_editor_save_button: true,
        show_editor_small_size_button: true,
        show_editor_square_button: true,
        show_editor_tool_columns: true,
        show_editor_upload_button: true,
        tabella_supporto: "disegno",
        titolo_editor: "Editor",
        visible: true,
      },
      key_segnalazioni: 0,

      // Modals
      conferma_stampa_visible: false,
      conferma_stampa_e_chiudi_visible: false,
      dialog_salva_fase: false,
      dialog_stampa_etichetta: false,
      dialog_segnalazioni: false,
      dialog_seriale_manuale: false,
      overlay: false,
      overlay_stampa: false,

      // Array

      headers: [
        {
          text: "Fase",
          value: "fase",
          filterable: false,
          sortable: false,
        },
        {
          text: "Seriale",
          value: "seriale",
          filterable: false,
          sortable: false,
        },
        {
          text: "Peso Lordo",
          value: "peso_lordo",
          filterable: false,
          sortable: false,
        },
        {
          text: "Tara",
          value: "tara",
          filterable: false,
          sortable: false,
        },
        {
          text: "Peso Netto",
          value: "peso_netto",
          filterable: false,
          sortable: false,
        },
        {
          text: "Temperatura",
          value: "temperatura",
          filterable: false,
          sortable: false,
        },
        {
          text: "Umidità",
          value: "umidita",
          filterable: false,
          sortable: false,
        },
      ],
      headers_seriali_manuali: [
        {
          text: "Seriale",
          value: "seriale",
          sortable: false,
        },
        {
          text: "Fase Ultima Registrazione",
          value: "fase_ultima_registrazione",
          sortable: false,
        },
        {
          text: "Selezione",
          value: "selezionato",
          sortable: false,
          width: "100px",
        },
      ],
      items_fase_precedente: new Array(),
      items_seriali_manuali: new Array(),
      items_magazzini: [],
    };
  },
  methods: {
    async apriDialog() {
      if (this.work_order.fase_precedente == null) {
        // Se non c'è la quantità blocco tutto.
        if (
          this.carrello.peso_lordo == null ||
          this.carrello.peso_lordo == ""
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Indicare un peso lordo non nullo."
          );
          return;
        }

        if (
          this.carrello.peso_lordo == null ||
          this.carrello.peso_lordo == ""
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Indicare un peso tara non nullo."
          );
          return;
        }

        if (this.carrello.peso_lordo - this.carrello.tara <= 0) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Il peso lordo deve essere maggiore del peso tara."
          );
          return;
        }

        this.dialog_stampa_etichetta = true;
      } else {
        this.overlay = true;
        await this.getSerialiCarrello(1);
        this.overlay = false;

        this.dialog_stampa_etichetta = true;
      }
    },
    chiudiFase(chiudi_fase) {
      if (this.items_magazzini.length > 0) {
        let request = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "registrafase",
            token: localStorage.getItem("user_token"),
            id_commessa_dettaglio: this.work_order.id_commessa_dettaglio,
            id_magazzino: this.id_magazzino_sel,
            quantita: this.carrello.peso_netto,
            peso_lordo: this.carrello.peso_lordo,
            tara: this.carrello.tara,
            flag_fase_ultima: this.work_order.flag_fase_ultima,
            seriale: this.carrello.seriale,
            chiudi_fase: chiudi_fase,
            temperatura:
              this.carrello.temperatura == null ? 0 : this.carrello.temperatura,
            umidita: this.carrello.umidita == null ? 0 : this.carrello.umidita,
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status == 200) {
              this.$refs.SnackbarQV.print("success", "Fase Registrata");
              this.$emit("registraFase");
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione con il server."
              );
            }
          })
          .catch((err) => {
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione con il server."
            );
          });
      }
    },
    calcoloPesoNettoDelta() {
      this.delta = isNaN(this.delta) ? 0 : this.delta;
      this.carrello.peso_netto = this.carrello.peso_lordo - this.carrello.tara;
      if (
        this.carrello.peso_netto > 0 &&
        this.items_fase_precedente.length > 0
      ) {
        let carrello_fase_precedente =
          this.items_fase_precedente[this.items_fase_precedente.length - 1];

        this.delta =
          carrello_fase_precedente.peso_lordo - this.carrello.peso_lordo;
        this.delta_perc = Math.round(
          (carrello_fase_precedente.peso_lordo - this.carrello.peso_lordo) /
            (carrello_fase_precedente.peso_netto / 100)
        );
      }
    },
    clickAvanza() {
      /* Se ho un seriale o se sono alla prima
       * fase apro la finsetra di dialogo di
       * registraizone, altrimenti stampo una
       * snackbar e chiedo all'utente di leggere
       * un codice QR per avere i dati che mi servono.  */
      if (
        this.carrello.seriale != -1 ||
        this.work_order.fase_precedente == null
      ) {
        this.dialog_salva_fase = true;
      } else {
        this.$refs.SnackbarQV.print(
          "orange",
          "Leggere un QR code o selezionare un seriale su cui registrare."
        );
      }
    },
    async clickSelezioneManualeSeriale() {
      // Apro l'overlay di caricamento.
      this.overlay = true;
      await this.getSerialiCarrello(0);

      /* Chiudo l'overlay e apro la finestra
       * di selezione del seriale. */
      this.overlay = false;
      this.dialog_seriale_manuale = true;
    },
    getSerialiCarrello(flag_ristampa) {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getserialicarrello",
          token: localStorage.user_token,
          id_commessa: this.work_order.id_commessa,
          id_commessa_dettaglio: this.work_order.id_commessa_dettaglio,
          flag_ristampa: flag_ristampa,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_seriali_manuali = res.data.result.seriali;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
          return false;
        });
    },
    selezioneManualeSeriale(arg) {
      this.detectQrCode(arg);

      this.dialog_seriale_manuale = false;
    },
    stampaQR(ristampa, chiudi_fase, cambio_lotto, seriale) {
      if (this.work_order.fase_precedente != null && seriale == -1) {
        return this.$refs.SnackbarQVStampa.print(
          "orange",
          "Scansionare un qr code o selezionare un carrello."
        );
      }
      if (
        ristampa == 0 &&
        (this.carrello.peso_lordo <= 0 || this.carrello.tara <= 0)
      ) {
        return this.$refs.SnackbarQVStampa.print(
          "orange",
          "Inserire peso lordo e tara."
        );
      }
      if (ristampa == 0 && this.delta < 0) {
        return this.$refs.SnackbarQVStampa.print(
          "orange",
          "Il delta non puo essere negativo."
        );
      }

      if (
        this.work_order.fase_precedente == null &&
        seriale == -1 &&
        cambio_lotto == 0
      ) {
        return this.$refs.SnackbarQVStampa.print(
          "orange",
          "Non c'è ancora un lotto precedente."
        );
      }

      // metodo che stampa il QR e registra i valori del carrello
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "registraestampacarrellogenerico",
          token: localStorage.user_token,
          id_articolo: this.work_order.id_articolo,
          id_commessa: this.work_order.id_commessa,
          id_commessa_dettaglio: this.work_order.id_commessa_dettaglio,
          seriale: seriale,
          peso_lordo: this.carrello.peso_lordo,
          tara: this.carrello.tara,
          peso_netto: this.carrello.peso_netto,
          chiudi_fase: chiudi_fase,
          ristampa: ristampa,
          temperatura:
            this.carrello.temperatura == null ? 0 : this.carrello.temperatura,
          umidita: this.carrello.umidita == null ? 0 : this.carrello.umidita,
          cambio_lotto: cambio_lotto,
        },
      };

      // Attivo l'overlay di caricamento.
      this.overlay_stampa = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_stampa = false;
          if (res.status === 200) {
            this.carrello.base64 = res.data.result;
            this.$refs.SnackbarQV.print("success", "Carrello registrato.");
            // se il carrello e stato salvato correttamente lancio il metodo
            // per visualizzare il codice qr in arrivo dalla response
            this.showPdfViewer();
            this.dialog_stampa_etichetta = false;
            this.items_fase_precedente = [];
            this.carrello = new Carrello();
            this.$emit("registraFase");
          } else if (res.status === 228) {
            this.$refs.SnackbarQV.print(
              "orange",
              "Materia prima non sufficiente."
            );
          } else if (res.status === 227) {
            this.overlay_stampa = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Codice di sotto-famiglia non assegnato per questo articolo."
            );
          }
        })
        .catch((err) => {
          this.overlay_stampa = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );

          this.overlay_stampa = false;
        });
    },
    showPdfViewer() {
      console.log("entrato show viewer");
      const b64toBlob = (b64Data, sliceSize = 512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: "application/pdf" });
        return blob;
      };
      const blob = b64toBlob(this.carrello.base64);
      const blob_url = URL.createObjectURL(blob);
      // apre la pagina con l'anteprima del pdf del qr creato dal BE
      window.open(blob_url, "_blank");
    },
    closeSegnalazioni() {
      this.dialog_segnalazioni = false;
    },
    chiudiDialog() {
      this.$emit("chiudiRegistraPeso");
      this.carrello = new Carrello();
      this.items_fase_precedente = [];
    },
    apriDialogSegnalazioni() {
      this.dialog_segnalazioni = true;
      this.key_segnalazioni = this.key_segnalazioni == 0 ? 1 : 0;
    },
    async detectQrCode(arg) {
      if (typeof parseInt(arg) !== "number") {
        return this.$refs.SnackbarQV.print(
          "orange",
          "Il QR code non è conforme, impossibile acquisire i dati."
        );
      }
      await this.getDettaglioCarrello(arg);
      this.calcoloPesoNettoDelta();
    },
    handleSalvatiDisegni(arg) {
      const obj_tmp = {
        id_segnalazione: -1,
        pk_riferimento: arg.pk_riferimento,
        id_riferimento: arg.id_riferimento,
        riferimento: arg.riferimento,
        tipo: arg.tipologia,
        note: arg.descrizione,
        cod_documento: this.input_args.cod_documento,
        num_documento: this.input_args.num_documento,
        cod_articolo: this.input_args.cod_articolo,
        data_documento: this.input_args.data_documento,
      };

      this.dialog_segnalazioni = false;
      this.overlay = true;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setsegnalazioni",
          segnalazioni: [obj_tmp],
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            const request2 = {
              controller: "Magazzino",
              method: "PUT",
              richiesta: {
                action: "setsegnalazioniimmagini",
                token: localStorage.user_token,
                immagini: arg.imgs,
                id_segnalazione: res.data.segnalazioni[0].id_segnalazione,
              },
            };

            this.$store
              .dispatch("api", request2)
              .then((res2) => {
                this.overlay = false;
                if (res2.status === 200) {
                  this.$refs.SnackbarQV.print(
                    "success",
                    "Segnalazione registrata con successo!"
                  );
                }
              })
              .catch((err) => {
                this.overlay = false;
                console.error(err);
                this.$refs.SnackbarQV.print(
                  "error",
                  "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
                );
              });
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
          );
        });
    },
    // prendi i veicoli dal db
    getDettaglioCarrello(seriale) {
      this.items_fase_precedente = [];
      const getqrcodecarrello = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getqrcodecarrello",
          token: localStorage.getItem("user_token"),
          seriale: seriale,
        },
      };
      this.overlay = true;
      return this.$store
        .dispatch("api", getqrcodecarrello)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (
              res.data.result[res.data.result.length - 1]
                .id_commessa_dettaglio ==
                this.work_order.id_commessa_dettaglio - 1 ||
              res.data.result[res.data.result.length - 1]
                .id_commessa_dettaglio == this.work_order.id_commessa_dettaglio
            ) {
              this.carrello = new Carrello();
              let carrello_tmp = new Carrello();
              res.data.result.forEach((e) => {
                carrello_tmp = new Carrello(e);
                carrello_tmp.peso_netto = e.quantita;

                this.items_fase_precedente.push(
                  JSON.parse(JSON.stringify(carrello_tmp))
                );
              });
              this.carrello.peso_lordo =
                res.data.result[res.data.result.length - 1].peso_lordo;
              this.carrello.seriale =
                res.data.result[res.data.result.length - 1].seriale;
              this.carrello.id_commessa_dettaglio =
                res.data.result[
                  res.data.result.length - 1
                ].id_commessa_dettaglio;
              this.carrello.tara =
                res.data.result[res.data.result.length - 1].tara;
              this.carrello.temperatura =
                res.data.result[res.data.result.length - 1].temperatura;
              this.carrello.umidita =
                res.data.result[res.data.result.length - 1].umidita;
            } else {
              if (
                res.data.result[res.data.result.length - 1]
                  .id_commessa_dettaglio > this.work_order.id_commessa_dettaglio
              ) {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Il carrello scansionato appartiene a fasi successive"
                );
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Il carrello scansionato appartiene a fasi precedenti"
                );
              }
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
            );
            return false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
          return false;
        });
    },
    getMagazzini() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolomagazzini",
          token: localStorage.getItem("user_token"),
          id_articolo: this.work_order.id_articolo,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            // Registro i magazzini selezionabili.
            this.items_magazzini = res.data;

            /* Se ci sono magazzini selezionabili, precompilo
             * il form selezionando di default il primo.*/
            if (this.items_magazzini.length > 0) {
              this.id_magazzino_sel = this.items_magazzini[0].id_magazzino;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
  },
  mounted() {
    // Registro il lotto di produzione attuale.
    this.carrello.seriale =
      this.work_order.id_lotto_commessa == null ||
      this.work_order.id_lotto_commessa == ""
        ? -1
        : this.work_order.id_lotto_commessa;

    // Registro i magazzini disponibili per un eventuale versamento.
    this.getMagazzini();

    /* Preparo le prop per il componente delle
     * segnalazioni anomalie mediante WindowFrame. */
    this.input_args.cod_documento = this.work_order.cod_fase;
    this.input_args.num_documento = this.work_order.id_commessa_dettaglio;
    this.input_args.cod_articolo = this.work_order.cod_articolo;
    this.input_args.data_documento = moment().format("YYYY-MM-DD");
  },
};
</script>
<style>
</style>